import React, {Component} from "react";
import Script from "react-load-script";
import {map} from "lodash";
import {message, Select} from "antd";
import * as yup from "yup";
import moment from "moment-timezone";
import {PlusOutlined} from '@ant-design/icons';
import { aboutUsData } from "../../../../Assets/data/aboutUsList";
import Axios from 'axios';

const {Option} = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class BasicDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zipcodeCheck: null,
      zipcode: '',
      franchises: [],
      customerName: '',
      address: {address: '', city: '', state: '', zip_code: ''},
      phone_numbers: [],
      emails: [],
      authorizedUser: [],
      phone: '',
      email: '',
      username: '',
      customer: {},
      hear_about_us: 'none',
    }
  }

  componentDidMount = () => {
    const {customerId, currentTab} = this.props;
    if (customerId && currentTab === 0) {
      this.setState({ loader: true });
      this.props.getLeadById(customerId); //get lead customer data
    }
    const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'))
    this.setState({
      zipcode: basicDetail?.zipcode || '',
      hear_about_us: basicDetail?.hear_about_us,
      customerName: basicDetail?.customerName,
      address: basicDetail?.address,
      phone_numbers: basicDetail?.phone_numbers,
      emails: basicDetail?.emails?.length > 0 ? basicDetail?.emails : [{email: basicDetail?.leadData?.email, primary: true}],
      authorizedUser: basicDetail?.authorizedUser
    }, () => this.validate())

  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({loader: false})
    // check zipcode
    if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && nextProps?.zipcodeCheck?.data?.results?.length > 0) {
      this.setState({zipcodeCheck: true, franchises: nextProps?.zipcodeCheck?.data?.results}, () => this.validate());
    } else {
      this.setState({zipcodeCheck: false, franchises: []}, () => this.validate());
    }

    // get lead customer data
    if (nextProps?.customerList && Object.keys(nextProps?.customerList?.customer).length > 0) {
      const customer = nextProps?.customerList?.customer;
      if (JSON.stringify(customer) !==  JSON.stringify(this.state.customer)) {
        this.setState({customer, customerName: `${customer?.first_name} ${customer?.last_name}`,
          address: customer?.address?.[0],
          emails: customer?.emailaddress_set?.length > 0 ? customer?.emailaddress_set : [{email: customer?.email, primary: true}],
          phone_numbers: customer?.phone_numbers || [],
          authorizedUser: customer?.authorizedUser || [],
          hear_about_us: customer?.hear_about_us,
        }, () => {
          if (this.refs["address"]) {
            const {address} = this.state;
            let addressStr = address?.address ? `${address?.address}` : '';
            addressStr += address?.city ? `, ${address?.city}` : '';
            addressStr += address?.state ? `, ${address?.state}` : '';
            addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';
            this.refs["address"].value = addressStr
          }
          this.validate();
        });
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }
  // on start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({address: obj}, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address');
        }
        this.validate()
      });
    }).catch((err) => {
      console.log(err)
    })
  }

  // on service detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.validate())
  }

  //on change
  onChange = (row, name) => {
    const {phone_numbers, emails, authorizedUser} = this.state;
    let data = name === 'phone' ? phone_numbers : name === 'email' ? emails : authorizedUser;
    data.splice(row, 1);
    this.setState({[name === 'phone' ? 'phone_numbers' : name === 'email' ? 'emails' : 'authorizedUser']: data});
  };

  //on add
  onAdd = (name) => {
    const {phone_numbers, emails, authorizedUser, username, phone, email,customer,hear_about_us} = this.state;
    if (name === 'phone') {
      phone_numbers.push({phone: phone, can_send_sms: false, primary: false, type: 'home_phone' });
      this.setState({phone_numbers}, () => {this.onClear(); this.validate()});
    } else if (name === 'email') {
      let NewEmails = emails && emails.length && emails.filter(email => {
        return !email.email.includes('doody.com');
      });
      NewEmails.push({email, primary: NewEmails?.length === 0});
      Object.assign(customer, { 'is_dummy_email': false })
    
      this.setState({emails:NewEmails,customer}, () => {this.onClear(); this.validate()});
    } else {
      authorizedUser.push({username, created_at: moment().format('MM/DD/YYYY')});
      this.setState({authorizedUser}, () => this.onClear());
    }
  };

  // on clear
  onClear = () => {
    this.setState({phone: '', email: '', username: ''});
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on zip code changed
  onZipcodeChange = (e) => {
    this.setState({zipcode: e.target.value});
    if (e.target.value.length === 5) {
      this.props.setLoader(true);
      this.props.checkZipCode({addressable_zip_codes__contains: e.target.value, close: false}); // check zip code
    } else {
      this.setState({zipcodeCheck: false}, () => this.validate())
    }
  };

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // validate required fields
  validate = () => {
    const {phone_numbers, emails, customerName, address, zipcodeCheck, hear_about_us} = this.state;

    const schema = yup.object().shape({
      zipcodeCheck: yup.bool().oneOf([true]),
      customerName: yup.string().required('Name is required'),
      address: yup.object().shape({
        address: yup.string().required('address is required.'),
        city: yup.string().required('city is required.'),
        state: yup.string().required('state is required.'),
        zip_code: yup.string().required('zip code is required.'),
      }),
      phone_numbers: yup.array(yup.object({
        phone: yup.string().required('Phone is required')
      })).required("Phone number is required"),
      emails: yup.array(yup.object({
        email: yup.string().required('Email is required')
      })).required("Email Address is required"),
    });

    const data = {
      zipcodeCheck,
      customerName,
      address,
      phone_numbers,
      emails,
      hear_about_us
    };

    schema.validate(data, { abortEarly: false }).then(() => {
      setTimeout(() => {
        this.setState({isBasicDetail: true, errors: {}}, () => {
          this.props.validateBasicInfo(true);
        });
      }, 200);
    }).catch(() => {
      setTimeout(() => {
        this.setState({errors: {}, isBasicDetail: false}, () => {
          this.props.validateBasicInfo(false);
        });
      }, 200);
    });
  };

  // render phone numbers
  renderPhoneNumbers = () => {
    const {phone_numbers, phone} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Phone Numbers</h5>
        <div className="inline-check-list gcheck">
          {
            map(phone_numbers, (item, index) =>  <div className="fitem-check" key={`phoneNumber${index}`}>
              <input type="checkbox" className="fitem-ck-input" id={`checkboxPhone${index}`} name={`checkboxPhone${index}`} checked={item?.primary} readOnly />
              <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt black">{`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}</label>
              {/*<a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'phone')}}><u>Remove</u></a>*/}
            </div> )
          }
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="phone" type="text" placeholder="Add New Phone Number" value={phone} maxLength={"10"}
            max={"10"} onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}/>
          <button className={`btn fitem-ricon ${phone.length !== 10 ? 'disabled' : 'btn-warning'}`}
            disabled={phone.length !== 10} onClick={() => this.onAdd('phone')}><PlusOutlined /></button>
        </div>
      </div>
    )
  }

  // render email addresses
  renderEmails = () => {
    const {emails, email,customer} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Email Addresses</h5>
        <div className="inline-check-list gcheck">
          {map(emails, (item, index) => (item?.email && !customer?.is_dummy_email && !item.email.includes('doody.com')) ? <div className="fitem-check" key={`email${index}`}>
            <input type="checkbox" className="fitem-ck-input" id={`checkboxEmail${index}`} name={`checkboxEmail${index}`} checked={item?.primary} readOnly />
            <label htmlFor={`checkboxEmail${index}`} className="fitem-ck-txt black">{`${item?.email} ${item?.primary ? '(Primary)' : ''}`}</label>
            {/*<a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'email')}}><u>Remove</u></a>*/}
          </div> :''
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input
            name="email"
            type="text"
            value={email}
            placeholder="Add New Email Address"
            onChange={(e) => this.onTextChange(e)}
          />
          <button className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(email)} onClick={() => this.onAdd('email')}><PlusOutlined /></button>
        </div>
      </div>
    )
  };

  // render authorized proposal
  renderAuthorizedUsers = () => {
    const {authorizedUser, username} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Authorized Users</h5>
        <div className="inline-check-list gcheck">
          {map(authorizedUser, (item, index) => <div className="fitem-check flex" key={`user${index}`}>
            <b className="d-block">{item?.username}</b>
            <div className="flex">
              <span className="mr-2">{`Added ${moment(item?.created_at)?.format('MM/DD/YYYY')}`}</span>
              <a className="red" href={'/#'} onClick={(e) => {e.preventDefault(); this.onChange(index, 'authorizedUser')}}><u>Remove</u></a>
            </div>
          </div>
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="username" type="text" placeholder="Add New Authorized User" value={username}
            onChange={(e) => this.onTextChange(e)}/>
          <button className={`btn fitem-ricon ${!username ? 'disabled' : 'btn-warning'}`}
            disabled={!username} onClick={() => this.onAdd('authorizedUser')}><PlusOutlined /></button>
        </div>
      </div>
    )
  }
  // on service detail change
  onTextChangeSource = (e, type) => {
    console.log("************",e.target.value,type)
    const value = type === 'bool' ? e.target.checked : e.target.value;
    //this.setState({hear_about_us: e.target.value})
    this.setState({ [e.target.name]: [value] }, () => this.setState({isLocalValueChanged: true}))
  }
  // render Lead source
  renderLeadSource = () => {
    const {hear_about_us} = this.state;
    return (
      <div>
        <h5 className=" mt-30">How did you hear about us</h5>
        <div className="inline-check-list gcheck">
            
          <Select
            name="hear_about_us"
            value={hear_about_us}
            placeholder="Select the source"
            onChange={(e) => this.onTextChangeSource({ target: { name: 'hear_about_us', value: e } })}
          >
            <Option value='none' selected disabled>Select</Option>
            {aboutUsData?.map((item) => (
              <Option id={item.id} value={item.value} key={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>

        </div> 
      </div>
    )
  };

  render() {
    const {zipcodeCheck, zipcode, franchises, customerName, address} = this.state;
    const franchiseName = franchises?.map((obj) => obj?.name) || [];

    let addressStr = address?.address ? `${address?.address}` : '';
    addressStr += address?.city ? `, ${address?.city}` : '';
    addressStr += address?.state ? `, ${address?.state}` : '';
    addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';

    return (
      <div className="aleft">
        <h4>Do we service this area?</h4>
        <p>If you are here, this is for a new customer calling right now. First of all, take their zipcode for their service address to make sure we service this area.</p>
        <div className="form-group">
          <div className="fitem">
            <label>Service Zipcode</label>
            <input type="text" placeholder="Zipcode" name="zipcode" max={5} maxLength={5} value={zipcode}
              onChange={(e) => this.onZipcodeChange(e)}/>
          </div>
          {zipcode ? zipcodeCheck ? <div className="greenbox mb-30">
            <b className="d-block">We cover this area.</b>
            <b className="d-block">{`This is under the ${franchiseName?.toString()} Franchise.`}</b>
          </div> :
            <div className="dangerbox mb-30">
              <b className="d-block">We don’t currently have any franchises covering this area. Save their email to notify them if we move into this area. </b>
            </div> : ''}
        </div>
        <div className="form-group">
          <h4>Contact Information</h4>
          {zipcodeCheck && <div className="fitem">
            <label>Customer Name</label>
            <input type="text" placeholder="Customer Name" name="customerName" value={customerName} onChange={(e) => this.onTextChange(e)}/>
          </div>}
          {zipcodeCheck && <div className="google_search_place fitem">
            <label>Address (Service)</label>
            <Script
              url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
              onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
            />

            <input
              autoComplete="off"
              type="text"
              ref="address"
              className={'form-control mb-10'}
              placeholder={addressStr ? addressStr : "Location"}
              name="google_address"
              id="google_address"
              onChange={(e) => {
                if (!e.target.value) {
                  this.setState({
                    address: { address: '', state: '', city: '', zipcode: '' }
                  }, () => this.validate())
                }
              }}
            />
          </div>}
        </div>
        {zipcodeCheck ? this.renderPhoneNumbers() : ''}
        {this.renderEmails()}
        {zipcodeCheck ? this.renderAuthorizedUsers() : ''}
        {this.renderLeadSource()}
      </div>
    )
  }
}

export default BasicDetail;